import styled from '@emotion/styled';
import { buttonStyles } from '..';
import { WrapperPropTypes } from './TextEditor.types';

export const InlineToolbar = styled.div`
  display: flex;
  gap: 0.25rem;
`;

export const ToolbarItem = styled.button<{ $active: boolean }>`
  width: 29px;
  height: 29px;

  border-radius: 0.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ $active }) => ($active ? '#5fa3a9' : '#525255')};
  border: 2px solid ${({ $active }) => ($active ? '#5fa3a9' : 'transparent')};
  transition: all 0.2s;
  position: relative;
`;

type PopperProps = { $height: number; $width: number };

export const PopperToolbar = styled.div`
  z-index: 10000;
`;

export const InputLabel = styled.label`
  font-size: 1rem;
  color: #525255;
  margin-bottom: 0.25rem;
  margin-left: 0.125rem;
`;

export const PopperWrapper = styled.div<PopperProps>`
  height: ${({ $height }) => $height + 5}px;
  width: ${({ $width }) => $width + 5}px;

  ${PopperToolbar} {
    height: ${({ $height }) => $height}px;
    width: ${({ $width }) => $width}px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 0.75rem;
`;

export const AddButton = styled.button`
  ${buttonStyles.btn};
  &:not(:disabled):hover {
    ${buttonStyles.btnHover}
  }
  &:disabled {
    ${buttonStyles.btnGray}
    cursor: not-allowed;
  }
`;

export const CancelButton = styled(AddButton)`
  ${buttonStyles.outline}
  &:hover {
    ${buttonStyles.btn}
  }
`;

export const Input = styled.input`
  margin-bottom: 1rem;
  border: 2px solid #f3f4f8;
  padding: 0.5rem 0.75rem;
  border-radius: 0.75rem;
  outline: none;
  font-size: 1rem;
  color: #525255;
  &:focus {
    border-color: #5fa3a9;
  }
`;

export const Wrapper = styled.div<WrapperPropTypes>`
  .wrapper {
    background-color: #fff;
    border-radius: 1.75rem;
    border: 2px solid #f3f4f8;
    min-height: ${({ minHeight }) => minHeight.mobile}px;
    max-height: ${({ maxHeight }) => maxHeight.mobile}px;
    position: relative;
    transition: border-color 0.2s;
    :focus-within {
      border-color: #5fa3a9;
    }
    .toolbar {
      position: sticky;
      top: 0;
      background-color: #fff;
      z-index: 1;
      display: flex;
      margin: 0 1.875rem;
      padding: 1rem 0;
      border-bottom: 1px solid #f3f4f8;
      gap: 0.25rem;
    }

    .editor {
      padding: 0.625rem 1.875rem 1.5rem;
      font-size: 1.125rem;
      position: relative;
      font-size: 1.125rem;
      color: #525255;
      font-family: 'Pangran', sans-serif;
      overflow: scroll;
      max-height: calc(${({ maxHeight }) => maxHeight.mobile}px - 4rem);
      min-height: calc(${({ minHeight }) => minHeight.mobile}px - 4rem);
      margin-top: -2px;
      cursor: text;
      a {
        color: #5fa3a9;
      }

      [class*='Placeholder'] {
        color: #bababa;
        position: absolute;
        left: 0.875rem;
        right: 0;
      }
    }
    &:focus-within {
      border-color: #5fa3a9;
    }
  }

  @media screen and (min-width: 640px) {
    .wrapper {
      min-height: ${({ minHeight }) => minHeight.desktop}px;
      max-height: ${({ maxHeight }) => maxHeight.desktop}px;
      .editor {
        max-height: calc(${({ maxHeight }) => maxHeight.desktop}px - 4rem);
        min-height: calc(${({ minHeight }) => minHeight.desktop}px - 4rem);
      }
    }
  }
`;
